import React from 'react';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import SearchQueueLinkByStatus from 'areas/shared/components/formatter/SearchQueueLinkByStatus';

const columns = [
	{ key: 'statusName', name: 'APPs by Status', width: 300, sortable: false },
	{ key: 'range0To30DaysSinceStartCount', name: '<30 Days', formatter: SearchQueueLinkByStatus, getRowMetaData: (row) => [row,1], sortable: false },
	{ key: 'range30To60DaysSinceStartCount', name: '30-60 Days', formatter: SearchQueueLinkByStatus, getRowMetaData: (row) => [row,2], sortable: false },
	{ key: 'range60PlusDaysSinceStartCount', name: '+60 Days', formatter: SearchQueueLinkByStatus, getRowMetaData: (row) => [row,3], sortable: false },
	{ key: 'totalCount', name: 'Total', formatter: SearchQueueLinkByStatus, getRowMetaData: (row) => [row,null], sortable: false }
];

class ApplicationByStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
        return {
			list: []
		};
    }

    componentDidMount() {
		this.handleSearch();
    }

	handleSearch = (filters, callback) => {
        this.setState({
			list: []
        }, function () {
            this.search(null, callback);
        });
    }

	search = (opts, callback) => {
        const rq = Object.assign({}
		);

		var state = {
			list: []
		};

        new API().post(APIModules.Admin.url('/dashboard/getApplicationsByStatus'), rq,
            {
                success: (r) => {
					state = {
                        list: r.data.items
                    };
					
					// Store search results
                    this.setState(state);

                    // Callback
                    if (callback)
                        callback();
                }
			});
			
			return state;
    }

	render() {
		return (
			<React.Fragment>
				<div className="apps-by-status-grid">
					<Grid
						columns={columns}
						items={this.state.list}
						height={210}
						rowKey="certificationStatusCode"
						name="default" />
				</div>
				<table className="dashboard-print-table apps-by-status-print">
					<thead>
						<tr>
							<th>APPs by Status</th>
							<th>&lt;30 Days</th>
							<th>30-60 Days</th>
							<th>+60 Days</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						{this.state.list.map((row, i) => (
							<tr key={i}>
								<td>{row.statusName}</td>
								<td>{row.range0To30DaysSinceStartCount}</td>
								<td>{row.range30To60DaysSinceStartCount}</td>
								<td>{row.range60PlusDaysSinceStartCount}</td>
								<td>{row.totalCount}</td>
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}

export default ApplicationByStatus;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/applicationsByStatus/ApplicationByStatus.js